import axios from 'axios'
import requestInterceptor from '../../requestInterceptor'
import responseInterceptor from '../../responseInterceptor'
import { reportServiceUrl } from '../../../../urls'

const headers = {
  'Content-Type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
}

const reportInstance = axios.create({
  baseURL: reportServiceUrl,
  headers,
})

reportInstance.interceptors.request.use(config => {
  return requestInterceptor(config)
}, error => Promise.reject(error))

reportInstance.interceptors.response.use(response => response, error => {
  return responseInterceptor(error)
})

export default reportInstance
